module.exports = __webpack_public_path__ + "media/images/suppliers/quartett-55f4a8bc4672ad934366e7a7bfa1fc57.png";